import React from "react";
import { useViewPitches } from "../../hooks/viewpitches/useViewPitches";
import ViewPitchesScreen from "../../components/viewpitches/ViewPitchesScreen";

/**
 * The staff entrance to View Pitches. Same screen as the club and coach routes;
 * the only differences are the fallback route when the request id is missing
 * (handled by `useViewPitches(true)`) and the absence of the club's
 * Free-Agents filter.
 */
const StaffViewPitches = () => {
  const vp = useViewPitches(true);

  if (!vp.tender) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F5F7FB]">
        <p className="text-[14px] text-[#6B7280]">
          Request data not found. Redirecting...
        </p>
      </div>
    );
  }

  return <ViewPitchesScreen {...vp} />;
};

export default StaffViewPitches;
